import { v4 as uuidv4 } from "uuid";
function chillHop() {
    return [
        {
            name: "Beaver Creek",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
            artist: "Aso, Middle School, Aviino",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10075",
            color: ["#205950", "#2ab3bf"],
            id: uuidv4(),
            active: true,
        },
        {
            name: "Daylight",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
            artist: "Aiguille",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9272",
            color: ["#EF8EA9", "#ab417f"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Keep Going",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
            artist: "Swørn",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9222",
            color: ["#CD607D", "#c94043"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Nightfall",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
            artist: "Aiguille",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9148",
            color: ["#EF8EA9", "#ab417f"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Reflection",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
            artist: "Swørn",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9228",
            color: ["#CD607D", "#c94043"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Under the City Stars",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
            artist: "Aso, Middle School, Aviino",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10074",
            color: ["#205950", "#2ab3bf"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Mirage",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/09/09fb436604242df99f84b9f359acb046e40d2e9e-1024x1024.jpg",
            artist: "Nymano, j'san",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10136",
            color: ["#5B5585", "#A1728B"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "burn my mind",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/06/52bd092974ccce9aa610c33f03575fc2d7f9c7d2-1024x1024.jpg",
            artist: "Tesk",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=8137",
            color: ["#AFD2CF", "#2E4D90"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Swimming",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/07/25a182a6a21588b8f7ad5605ba1118a8ea61bdc2-1024x1024.jpg",
            artist: "Sleepy Fish",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=7993",
            color: ["#72BED5", "#22183D"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "jam session",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/07/4b06cedf68f3f842d3a0fc13ae62564dec6056c8-1024x1024.jpg",
            artist: "Montell Fish",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9003",
            color: ["#8299BD", "#F6A19D"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "At Our Core",
            cover:
                "https://chillhop.com/wp-content/uploads/2020/07/8f8345d4f6a785737417ddd625a2d20664b244b6-1024x1024.jpg",
            artist: "fantompower",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9065",
            color: ["#EFB09F", "#691A1D"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Solstice",
            cover:
                "https://chillhop.com/wp-content/uploads/2021/03/e2cf41018e0c244f7f683dd6f6313551996a2952-300x300.jpg",
            artist: "Gritton",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=16175",
            color: ["#892D42", "#FDB28A"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "man it's late",
            cover:
                "https://i.scdn.co/image/ab67616d0000b273e61a3d49a9256ceb24892f73",
            artist: "mommy,Sleepy Fish",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=19064",
            color: ["#5A8CCD", "#F8DAC6"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "walnut",
            cover:
                "https://i.scdn.co/image/8380ec6d215299c0809bd5c3781aa4196155a502",
            artist: "Philanthrope,mommy",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9245",
            color: ["#6F6B6F", "#A4A29B"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Traveling Through Time",
            cover:
                "https://i.scdn.co/image/ab67616d0000b27355083ca2cc45761f673b35e7",
            artist: "xander",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=5834",
            color: ["#60322F", "#7A4353"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Phil Phol Vibe",
            cover:
                "https://chillhop.com/wp-content/uploads/2021/03/e2cf41018e0c244f7f683dd6f6313551996a2952-300x300.jpg",
            artist: "The BREED",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=16187",
            color: ["#892D42", "#FDB28A"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Camille & Leo (interlude)",
            cover:
                "https://i.scdn.co/image/ab67616d0000b273f24b2d91590ce7fbf131c27c",
            artist: "sadtoi",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=6039",
            color: ["#C27E51", "#788974"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "A Tribe Called Tenz",
            cover:
                "https://i.scdn.co/image/ab67616d0000b27339dcd686eba5179dd5a9f506",
            artist: "Ruck P",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=7922",
            color: ["#FBE0CB", "#2E3346"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Blue View",
            cover:
                "https://chillhop.com/wp-content/uploads/2021/03/e2cf41018e0c244f7f683dd6f6313551996a2952-300x300.jpg",
            artist: "Laavv",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=16216",
            color: ["#892D42", "#FDB28A"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Focus",
            cover:
                "https://i.scdn.co/image/ab67616d0000b27335db1818ab7690078ebd38f0",
            artist: "Ezzy",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=10335",
            color: ["#E2C6D4", "#7D7089"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Doin It",
            cover:
                "https://i.scdn.co/image/ab67616d0000b273e1d129b30434132abc145b53",
            artist: "Tesk",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=8927",
            color: ["#C5BFB4", "#8F7E70"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Bliss",
            cover:
                "https://i.scdn.co/image/ab67616d0000b2734dbbff68622228d0949f9803",
            artist: "Misha,Jussi Halme",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=9248",
            color: ["#0B1B2D", "#6E607A"],
            id: uuidv4(),
            active: false,
        },
        {
            name: "Feels",
            cover:
                "https://i.scdn.co/image/ab67616d0000b2731dc1cd60c7d66f661b9690c4",
            artist: "Gaustav Gaustav",
            audio: "https://mp3.chillhop.com/serve.php/?mp3=12158",
            color: ["#3A796F", "#8E977F"],
            id: uuidv4(),
            active: false,
        },

    ];
}

export default chillHop;